// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const TelegramIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="url(#telegram_svga)"
      d="M12 23a11 11 0 1 0 0-22 11 11 0 0 0 0 22"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M5.98 11.88q4.8-2.1 6.42-2.76c3.05-1.27 3.68-1.49 4.1-1.5.09 0 .3.02.43.13q.14.16.15.3c.02.09.03.28.02.43-.17 1.74-.88 5.96-1.25 7.91-.15.82-.45 1.1-.75 1.13-.64.06-1.12-.42-1.74-.83-.97-.63-1.52-1.03-2.46-1.65-1.08-.71-.38-1.1.24-1.75.16-.17 2.98-2.73 3.03-2.96 0-.03.01-.14-.05-.2-.07-.05-.16-.03-.23-.02q-.14.04-4.64 3.07-.65.45-1.19.44c-.4 0-1.15-.22-1.7-.4-.7-.23-1.25-.35-1.2-.73q.04-.3.82-.6"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="telegram_svga"
        x1={12}
        x2={12}
        y1={1}
        y2={22.84}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2AABEE" />
        <stop offset={1} stopColor="#229ED9" />
      </linearGradient>
    </defs>
  </svg>,
  "Telegram",
);
export default TelegramIcon;
